/**
 * Shared presentational helpers for the Assets module.
 */
import React from 'react';
import { X } from '@phosphor-icons/react';
import { formatUtcToIst, formatUtcToIstDate } from '../tickets/utils/datetime';

export const STATUS_BADGE = {
  available: '#DCFCE7', in_use: '#DBEAFE', assigned: '#DBEAFE',
  maintenance: '#FEF3C7', in_repair: '#FEF3C7', retired: '#F3F4F6',
  lost: '#FEE2E2', damaged: '#FEE2E2',
};

export const ROLE_BADGE = { manager: '#FEF3C7', lead: '#DBEAFE', member: '#F3F4F6' };

export const fmtLabel = (s) => (s || '').replace(/_/g, ' ');
export const fmtDate = (d) => formatUtcToIstDate(d);
export const fmtDateTime = (d) => formatUtcToIst(d);

export function ModalShell({ title, onClose, children, headerActions, testid }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '10px' }} data-testid={testid}>
      <div style={{ background: 'white', padding: '28px', width: '100%', maxWidth: '760px', maxHeight: '90vh', overflowY: 'auto', borderRadius: '8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <h2 style={{ fontSize: '15px', fontWeight: '600', fontFamily: 'IBM Plex Mono, monospace' }}>{title}</h2>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {headerActions}
            <button onClick={onClose} style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div style={{ marginBottom: '6px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: '500' }}>{label}</label>
      {children}
    </div>
  );
}

export function Detail({ label, value, mono, capitalize, block }) {
  return (
    <div style={block ? { marginBottom: '8px' } : undefined}>
      <p style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>{label}</p>
      <p style={{ fontSize: '12px', fontWeight: '500',
        fontFamily: mono ? 'IBM Plex Mono, monospace' : 'inherit',
        textTransform: capitalize ? 'capitalize' : 'none',
        whiteSpace: block ? 'pre-wrap' : 'normal' }}>
        {value || '—'}
      </p>
    </div>
  );
}
